import API from "Api";
import {
  CHASEUP_CHART,
  GET_HOME_LIST_ENDPOINT,
  GET_NO_OF_ALERT_ENDPOINT,
  ORDER_CHART,
  ORDER_SPEED,
  PAYMENT_CREATE,
  PAYMENT_LINK_CREATE,
  PAYMENT_LIST,
  SUBSCRIPTION_CANCEL,
  SUBSCRIPTION_CREATE,
  SUBSCRIPTION_UPDATE,
} from "./endpoints";

//Home Count List
export const getHomeListAPI = (payload) => {
  return API.post(GET_HOME_LIST_ENDPOINT, payload);
};

//No of Alert
export const getNoOfAlertAPI = (payload) => {
  return API.post(GET_NO_OF_ALERT_ENDPOINT, payload);
};

export const getorderSpeed = (payload) => {
  return API.post(ORDER_SPEED, payload);
};

export const getChaseUpChart = (payload) => {
  return API.post(CHASEUP_CHART, payload);
};

export const getOrderChart = (payload) => {
  return API.post(ORDER_CHART, payload);
};

export const getPaymentCreate = (payload) => {
  return API.post(PAYMENT_CREATE, payload);
};

export const getPaymentLinkCreate = (payload) => {
  return API.post(PAYMENT_LINK_CREATE, payload);
};

export const getPaymentList = (payload) => {
  return API.post(PAYMENT_LIST, payload);
};

export const getSubscriptionCreate = (payload) => {
  return API.post(SUBSCRIPTION_CREATE, payload);
};

export const getSubscriptionCancle = (payload) => {
  return API.post(SUBSCRIPTION_CANCEL, payload);
};

export const getSubscriptionUpdate = (payload) => {
  return API.post(SUBSCRIPTION_UPDATE, payload);
};
